import { RefundModal } from "./RefundModal";
import { show } from "@ebay/nice-modal-react";

/**
 * Display a modal dialog containing event history for a single Patient/Responsible Party.
 * @param patientId The ID of the P/RP to display.
 * @param transactionId The transaction id of the transaction being refunded.
 * @param triggerEventHistory Should onClose trigger event history modal.
 * @returns Promise representing dialog lifetime.
 */
export async function showRefundModal(patientId: number, transactionId: number, triggerEventHistory?: boolean) {
    return await show(RefundModal, { patientId, transactionId, triggerEventHistory });
}
